/**
 * @Author: chenyangui
 * @Description: 审批流程 - 付款通知单审批设置
 */

import request from '@/router/axios';
const hrcloudUrlPrefix = '/sys';

/**
 * @description: tree列表
 * @description: 获取客户所有公司包括子公司
 */
export function getPayApvlTreeList(obj) {
    return request({
        url: hrcloudUrlPrefix+'/org/getOrgAll',
        method: 'get',
        params: obj
    })
}

/**
 * @description: table列表
 * @description: 获取客户所有流程 含筛选
 */
export function getPayApvlTableList(obj) {
    return request({
        url: hrcloudUrlPrefix+'/wageApproval/getProcess',
        method: 'get',
        params: obj
    })
}

/**
 * @description: 下拉列表
 * @description: 按钮编码查询
 */
export function postPayApvlCodeList(obj) {
    return request({
        url: hrcloudUrlPrefix+'/code/getItemCode',
        method: 'get',
        params: obj
    })
}

/**
 * @description: 角色查询 table列表
 * @description: 角色查询 含分页
 */
export function getPayApvlPageRoleInfo(obj) {
    return request({
        url: hrcloudUrlPrefix+'/wageApproval/pageRoleInfo',
        method: 'get',
        params: obj
    })
}

/**
 * @description: 新增 编辑
 * @description: 流程修改 保存
 */
export function postPayApvlSaveProcess(obj) {
    return request({
        url: hrcloudUrlPrefix+'/wageApproval/saveProcess',
        method: 'post',
        data: obj,
        headers: {
            "Content-Type": 'application/json',
        }
    })
}

/**
 * @description: 编辑回显
 * @description: 跳转流程修改
 */
export function getPayApvlEdit(obj) {
    return request({
        url: hrcloudUrlPrefix+'/wageApproval/edit',
        method: 'get',
        params: obj,
    })
}

/**
 * @description: 禁用 启用
 * @description: 修改流程状态
 */
export function postPayApvlUpdateStatus(obj) {
    return request({
        url: hrcloudUrlPrefix+'/wageApproval/updateStatus',
        method: 'get',
        params: obj,
    })
}
